import ccFetch from '../ccFetch'

// does the request to logoff on cc-auth
// 		cc-auth does:
// 			- session invalidation on db
// 			- set-cookie to expire it (on the response)
// 			- 
// 		on success on xhr request above:
// 			- remove access token on localstorage
// 		call some function to notifies UI and redirect page
export default function(params) {
  return function logoff (cb) {
    const { authDomain, authLogoffUri } = params
    return ccFetch(`${authDomain}${authLogoffUri}`)
      .then(r => r.json())
      .then(r => {
        localStorage.removeItem("atk")
        cb()
      })
      .catch(err => console.error(err))
    
  }
}
